interface LoadingIconProps {
  message?: string;
  waiting?: boolean;
}

export function LoadingIcon({ message, waiting = false }: LoadingIconProps) {
  const displayMessage = message ?? (waiting ? 'Waiting...' : 'Loading...');

  return (
    <div className="flex flex-col items-center justify-center">
      <br />
      <div className="grid grid-cols-2 grid-rows-2 gap-0.5">
        <div className="w-[18px] aspect-square bg-[#F15A25] rounded-br-full animate-logo-pulse [animation-delay:0s]" />
        <div className="w-[18px] aspect-square bg-[#F15A25] rounded-br-full animate-logo-pulse [animation-delay:0.3s]" />
        <div className="w-[18px] aspect-square bg-[#F15A25] rounded-br-full animate-logo-pulse [animation-delay:0.9s]" />
        <div className="w-[18px] aspect-square bg-[#F15A25] rounded-br-full animate-logo-pulse [animation-delay:0.6s]" />
      </div>
      <span className="pt-2 text-xs text-slate-500">{displayMessage}</span>
      <br />
    </div>
  );
}
